import type { CSSProperties } from 'react';
import SectionHeading from '../components/SectionHeading';
import type { Colors } from '../theme';
import { LS_ROWS } from '../data';

interface Props {
  colors: Colors;
  mobile: boolean;
  sectionStyle: CSSProperties;
}

// The terminal box is deliberately black in both themes, so the text inside
// uses fixed light colors rather than theme tokens.
const META = "#c9c9c9";

export default function ContactSection({ colors, mobile, sectionStyle }: Props) {
  // The full five-column `ls -la` row is ~55 monospace chars; on a phone that
  // either wraps into noise or has to shrink to an unreadable 10px. Mobile keeps
  // the columns that carry meaning (perms, owner, value) and drops size + date.
  const metaStyle: CSSProperties = { color: META, minWidth: mobile ? undefined : "9ch" };

  return (
    <section id="contact" style={sectionStyle}>
      <SectionHeading colors={colors} mobile={mobile}>
        [spandan@portfolio ~/contact]$ ls -la
      </SectionHeading>

      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: 28,
        maxWidth: 720,
        alignSelf: mobile ? "center" : undefined,
        textAlign: mobile ? "center" : undefined,
        width: "100%",
      }}>
        <div style={{
          display: "flex",
          flexDirection: "column",
          gap: 14,
          width: "100%",
          boxSizing: "border-box",
          padding: mobile ? "16px 14px" : "20px 22px",
          borderRadius: 8,
          background: "rgba(0,0,0,0.85)",
          border: `1px solid ${colors.cardBorder}`,
          transition: "background .35s ease, border-color .35s ease",
        }}>
          <p style={{ margin: 0, fontSize: 13, color: META }}>total 5</p>

          <div style={{ display: "flex", flexDirection: "column", gap: 6, alignItems: "flex-start", width: "100%" }}>
            {LS_ROWS.map((r) => {
              const external = r.href.startsWith("http");
              return (
                <a
                  key={r.owner}
                  href={r.href}
                  target={external ? "_blank" : undefined}
                  rel={external ? "noopener noreferrer" : undefined}
                  style={{
                    display: "flex",
                    gap: mobile ? 8 : 10,
                    textDecoration: "none",
                    fontSize: 12,
                    lineHeight: 1.6,
                    // long values (the email) must break rather than widen the box
                    overflowWrap: "anywhere",
                    whiteSpace: "normal",
                    flexWrap: "wrap",
                    alignItems: "baseline",
                    padding: mobile ? "6px 0" : undefined,
                  }}
                >
                  <span style={{ color: META }}>{r.perms}</span>
                  <span style={metaStyle}>{r.owner}</span>
                  {!mobile && <span style={{ color: META, textAlign: "right", minWidth: "3ch" }}>{r.bytes}</span>}
                  {!mobile && <span style={metaStyle}>{r.date}</span>}
                  <span style={{ color: "#ff6b6b", fontWeight: 600, borderBottom: "1px dashed rgba(255,255,255,0.22)" }}>
                    {r.name}
                  </span>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
